/**
 * InvitationBadge Component
 *
 * Shows a count of pending reflection sharing invitations in the nav.
 * Polls every 5 minutes when the window is focused.
 */

import { useQuery } from "@tanstack/react-query";
import { Mail } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { getPendingInvitations } from "@/services/invitations";

export function InvitationBadge() {
  const navigate = useNavigate();

  const { data: invitations } = useQuery({
    queryKey: ["invitations", "pending"],
    queryFn: getPendingInvitations,
    refetchInterval: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: true,
  });

  const count = invitations?.length ?? 0;

  if (count === 0) return null;

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => navigate("/invitations")}
      title={`${count} pending invitation${count !== 1 ? "s" : ""}`}
      className="relative"
    >
      <Mail className="w-4 h-4" />
      <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] flex items-center justify-center rounded-full bg-red-500 dark:bg-red-600 text-white text-xs font-bold px-1">
        {count}
      </span>
    </Button>
  );
}
